<template>
  <div v-if="!loading">
    <charts-bar
      :key="key"
      class="view-loyalty-overview__chart"
      :datasets="datasets" 
      :labels="labels"
    ></charts-bar>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'LoyaltyProgramChart',

  props: {
    loading: {
      type: Boolean,
      default: true,
    },

    range: {
      type: Object,
    }
  },

  data() {
    return {
      key: 1
    }
  },

  computed: {
    ...mapState({
      state: state => state.loyalty.loyalty.kpis,
      kpis: state => state.loyalty.loyalty.kpis.value,
    }),

    months() {
      return [
        this.$t('sayl.january'),
        this.$t('sayl.febuary'),
        this.$t('sayl.march'),
        this.$t('sayl.april'),
        this.$t('sayl.may'),
        this.$t('sayl.june'),
        this.$t('sayl.july'),
        this.$t('sayl.august'),
        this.$t('sayl.september'),
        this.$t('sayl.october'),
        this.$t('sayl.november'),
        this.$t('sayl.december'),
      ].reverse()
    },

    days() {
      return [
        this.$t('sayl.monday'),
        this.$t('sayl.tuesday'),
        this.$t('sayl.wednesday'),
        this.$t('sayl.thursday'),
        this.$t('sayl.friday'),
        this.$t('sayl.saturday'),
        this.$t('sayl.sunday'),
      ].reverse()
    },

    dates() {
      let ret = []
      if(!this.loading && this.range) {
        let start = this.range.from
        let end = this.range.to
        let step = 'day'

        let temp = start
        let r = $dl.ranges.getByValue({ from: start, to: end })
        if(r.toString() === 'this_year' || r.toString() === 'last_12_months') {
          step = 'month'
        }
        
        while(temp < end) {
          ret.push(this.$moment(temp).toDate())
          temp = this.$moment(temp).add(1, step).toDate().getTime()
        }
      }
      return ret
    },

    labels() {
      let ret = !this.loading ? this.dates : []
      let format = 'DD/MM'
      
      let r = $dl.ranges.getByValue({ from: this.range.from, to: this.range.to })
      if(r.toString() === 'this_year' || r.toString() === 'last_12_months') {
        format = 'MM/YYYY'
      }
      return ret.map((d) => this.$moment(d).format(format))
    },

    datasets() {
      let ret = [
        { 
          label: this.$t('sayl-ecommerce.loyalty_rewarded'),
          backgroundColor: '#1480AB',
          data: []
        },
        {
          label: this.$t('sayl-ecommerce.loyalty_redeemed'),
          backgroundColor: '#CC4B23',
          data: [], 
        }
      ]

      if(!this.loading) {
        let charts = this.$basil.get(this.kpis, 'data', {})

        this.dates.forEach(date => {
          let d = this.$moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ss')
          let tmp = charts[d]
          let accrual = this.$basil.get(tmp, 'accrual', 0)
          let redemption = this.$basil.get(tmp, 'redemption', 0)
          ret[0].data.push(this._formatNumber(accrual))
          ret[1].data.push(-1 * this._formatNumber(redemption))
        })
      }

      return ret
    }
  },

  methods: {
    _formatNumber(value) {
      let ret = value 

      if(!this.$basil.isNil(ret)) {
        let int = parseInt(ret, 10)
        let float = ret - int
        if(float > 0 && float < 1) {
          ret = parseFloat(ret, 10).toFixed(2)
        } else {
          ret = parseInt(ret, 10)
        }
      } else {
        ret = 0
      }

      return ret
    },

    getLabels({ format, limit, range }) {
      let ret = []

      for(let i = 0; i < limit; i++) {
        ret.unshift(this.$moment().set('minute', 0).subtract(i, range).format(format))
      }

      return ret
    },
  },
}
</script>
